import {TextDetails, TextCard} from './Text';
import MicroIcon from '../shared/MicroIcon';
import HorizontalCardIconFactory from '../shared/HorizontalCardIconFactory';
import Icon from 'components/Icon';

const Micro = MicroIcon(Icon.OPTIONS.CARD_NOTEBOOK);

export const card = TextCard;
export const details = TextDetails;
export const micro = Micro;
export const icon = Micro;
export const horizontal = HorizontalCardIconFactory(Micro);
export const preview = TextCard;
